import { all, takeEvery, put, call } from "redux-saga/effects";
import actions from "./actions";
import { getList } from "../../helpers/fackBackend_Helper";

function* getDashboardDataResponse() {
  try {
    const response = yield call(getList, "/getAllCountDataforDashboard");
    if (response.Status) {
      yield put(actions.getDashboardDataSuccess(response));
    } else {
      yield put(actions.getDashboardDataFailed(response.Message));
    }
  } catch (error) {
    yield put(actions.getDashboardDataFailed(error));
  }
}

function* getChartDataResponse() {
  try {
    const response = yield call(getList, "/getDailyChartData");
    if (response.Status) {
      yield put(actions.getChartDataSuccess(response));
    } else {
      yield put(actions.getChartDataFailed(response.Message));
    }
  } catch (error) {
    yield put(actions.getChartDataFailed(error));
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.GET_DASHBOARD_DATA, getDashboardDataResponse)]);
  yield all([takeEvery(actions.GET_CHART_DATA, getChartDataResponse)]);
}
